
import React from 'react';
import Image from 'react-bootstrap/Image';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import androidCreator from '../../assets/images/AndroidCreator.png';
import PanelContext from '../../components/PanelContext/PanelContext';

function Home() {
    return <>
      <PanelContext title="Описание проекта Web-лаборатория">
          <Row>
            <Col>
              <Image src={androidCreator} thumbnail></Image>
            </Col>
            <Col>
              <p className="text-start">Web лаборатория, где можно проводить отладку и демонстрировать работу наших моделей.</p>
            </Col>
          </Row>
      </PanelContext>
    </>
  }
  
export default Home
